import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ComingSoonProvider } from "@/components/ComingSoon";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewProposal from "@/pages/NewProposal";
import Editor from "@/pages/Editor";
import Attachments from "@/pages/Attachments";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ComingSoonProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />

              {/* Protected */}
              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/new" element={<NewProposal />} />
                <Route path="/proposals/:id" element={<Editor />} />
                <Route path="/attachments" element={<Attachments />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </ComingSoonProvider>
      </AuthProvider>
    </div>
  );
}
